import { SelectDropdown, MaterialIcon } from "../components";

const SortDropdownPagination = ({
  showSortDropDown = true,
  allEntities,
  sortOption,
  setSortOption,
  currentPage,
  setCurrentPage,
  itemsPerPage = 3,
  dropdownData,
}) => {
  const startIndex = currentPage * itemsPerPage;
  const handleNext = () => {
    if (startIndex + itemsPerPage < allEntities.length) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  const totalPages = Math.ceil(allEntities.length / itemsPerPage);
  const handleFirstPage = () => {
    if (currentPage > 0) {
      setCurrentPage(0);
    }
  };
  const handleLastPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(totalPages - 1);
    }
  };

  if (allEntities.length <= 1) return null;

  return (
    <>
      {showSortDropDown && (
        <div className="d-flex align-items-center justify-content-around column-gap-1 sort-access-level border border-black border-start-0 border-bottom-0 border-end-0">
          <span className="mb-0">Sort By</span>
          <SelectDropdown
            dropdownData={dropdownData}
            selectClassName="w-100"
            wrapperClassName="col-md-4 col-10 mb-0"
            select={(selectedValue) => {
              setSortOption(selectedValue);
              setCurrentPage(0);
            }}
            value={sortOption}
          />
        </div>
      )}
      <div className="d-flex justify-content-around align-items-center access-level-pagination py-1 border-bottom-1 border-top-1">
        <span className="small">
          <strong>{startIndex + 1}</strong> to{" "}
          <strong>
            {Math.min(startIndex + itemsPerPage, allEntities.length)}
          </strong>{" "}
          of <strong>{allEntities.length}</strong>
        </span>
        <div className="d-flex align-items-center gap-2">
          <MaterialIcon
            iconName="first_page"
            click={handleFirstPage}
            wrapperClassName={`d-inline-flex align-items-center cursor-pointer ${
              currentPage === 0 ? "text-muted opacity-50" : "text-secondary"
            }`}
            iconClassName="material-icons-outlined"
          />
          <MaterialIcon
            iconName="chevron_left"
            click={handlePrevious}
            wrapperClassName={`d-inline-flex align-items-center cursor-pointer ${
              currentPage === 0 ? "text-muted opacity-50" : "text-secondary"
            }`}
            iconClassName="material-icons-outlined"
          />
          <span className="small">
            Page <strong>{currentPage + 1}</strong> of{" "}
            <strong>{totalPages}</strong>
          </span>
          <MaterialIcon
            iconName="chevron_right"
            click={handleNext}
            wrapperClassName={`d-inline-flex align-items-center cursor-pointer ${
              startIndex + itemsPerPage >= allEntities.length
                ? "text-muted opacity-50"
                : "text-secondary"
            }`}
            iconClassName="material-icons-outlined"
          />
          <MaterialIcon
            iconName="last_page"
            click={handleLastPage}
            wrapperClassName={`d-inline-flex align-items-center cursor-pointer ${
              startIndex + itemsPerPage >= allEntities.length
                ? "text-muted opacity-50"
                : "text-secondary"
            }`}
            iconClassName="material-icons-outlined"
          />
        </div>
      </div>
    </>
  );
};

export default SortDropdownPagination;
